import { ripsKeys, useTradingCardsClient } from '@/providers';
import { useQuery } from '@tanstack/react-query';

import { RipsPack } from './use-rips-games';

/** A pack from `/recent-packs`: same shape as a `/categories` pack, plus its category name. */
export type RipsRecentPack = RipsPack & {
    category: string;
};

type RecentPacksResponse = {
    packs: RipsRecentPack[];
};

/** The player's most recently ripped packs, most recent first. Disabled, so it only fetches from the lobby's focus effect. */
export const useRecentPacks = () => {
    const tradingCardsClient = useTradingCardsClient();

    return useQuery<RecentPacksResponse | null, Error, RipsRecentPack[]>({
        queryKey: ripsKeys.recentPacks(),
        queryFn: () => {
            return tradingCardsClient.fetch('/recent-packs', {
                method: 'GET',
            });
        },
        select: response => response?.packs ?? [],
        staleTime: Infinity,
        enabled: false,
    });
};
